

































































































import { defineComponent, reactive, toRefs, onMounted, computed, onBeforeUnmount } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import { SearchCondition, WebupHistory, WebupStatusEnum, WebupStatusNameEnum } from "../../modules/teacher/WebupList"

export interface Data {
  condition: SearchCondition
  webupHistories: WebupHistory[]
  submitted_at: string
  fields: any[]
  WebupStatusEnum: Readonly<{ImageReading: string; ImageReadError: string; ImageReadCompleted: string; DataRegistering: string; DataRegistrationError: string; DataRegistrationCompleted: string; Deleted: string;}>
  WebupStatusNameEnum: Readonly<{ImageReading: string; ImageReadError: string; ImageReadCompleted: string; DataRegistering: string; DataRegistrationError: string; DataRegistrationCompleted: string; Deleted: string;}>
  errors: string[]
  totalCount: number
  sheetTypeName: string
  isMounted: boolean
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
    'date-time-picker' : VueCtkDateTimePicker,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      webupHistories: new Array<WebupHistory>(),
      submitted_at: null,
      fields: [
        {key: "uploaded_at", label: "アップロード日時", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "submitted_at", label: "取込日", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "file_name", label: "ファイル名", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "uploaded_user_name", label: "アップロード者", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "registered_user_name", label: "登録者", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "file_name", label: "ファイル名", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "file_count", label: "枚数", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "status", label: "状態", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "error_msg", label: "エラー", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "detail", label: "画像一覧", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "destroy", label: "削除", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
      ],
      WebupStatusEnum: WebupStatusEnum,
      WebupStatusNameEnum: WebupStatusNameEnum,
      errors: [],
      totalCount: 0,
      sheetTypeName: null,
      isMounted: false,
    });

    const statusClassStyle = (status: number) => {
      let rtn: any = {};
      if(String(status) == state.WebupStatusEnum.ImageReading || String(status) == state.WebupStatusEnum.DataRegistering){
        rtn["flash"] = true;
      }
      return rtn;
    };

    const convertUploadedAt = (uploaded_at: string) => {
      return uploaded_at ? moment(uploaded_at).format('Y年M月D日 H:m:s') : "-";
    };

    const convertWebupStatusToText = (status: number) => {
      let rtn: string = "";
      if(status == Number(state.WebupStatusEnum.ImageReading)){
        rtn = state.WebupStatusNameEnum.ImageReading;
      }else if(status == Number(state.WebupStatusEnum.ImageReadError)){
        rtn = state.WebupStatusNameEnum.ImageReadError;
      }else if(status == Number(state.WebupStatusEnum.ImageReadCompleted)){
        rtn = state.WebupStatusNameEnum.ImageReadCompleted;
      }else if(status == Number(state.WebupStatusEnum.DataRegistering)){
        rtn = state.WebupStatusNameEnum.DataRegistering;
      }else if(status == Number(state.WebupStatusEnum.DataRegistrationError)){
        rtn = state.WebupStatusNameEnum.DataRegistrationError;
      }else if(status == Number(state.WebupStatusEnum.DataRegistrationCompleted)){
        rtn = state.WebupStatusNameEnum.DataRegistrationCompleted;
      }else if(status == Number(state.WebupStatusEnum.Deleted)){
        rtn = state.WebupStatusNameEnum.Deleted;
      }
      return rtn;
    };

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    const search = async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      context.root.$store.commit("setWebupListCondition", state.condition);

      state.condition.sheet_type = context.root.$store.state.sheet_type;

      // APIで登録済みレポート情報取得
      await http.get(`/api/teacher/webup_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.webupHistories = response.data.webup_histories.map((x: any) => new WebupHistory(x));
        state.totalCount = state.webupHistories.length > 0 ? response.data.webup_histories[0].total_count : 0;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。`);
        }
        context.root.$store.dispatch("goSheetList");
      });

      context.root.$store.dispatch("hideOverlay");
    };

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    const onDrop = async (file: any[]) => {

      if(file[0].name.includes(" ")){
        state.errors.push("ファイル名に半角スペースは使用できません。");
        return;
      }

      if(Common.getFileExtension(file[0].name) == "pdf"){
        // PDFの場合はファイルサイズ・ページ数チェック
        if(file[0].size > 31457280){
          state.errors.push("PDFのファイルサイズが30MBを超過しています。30MB以下にファイルを分割してアップロードしてください。");
          return;
        }

        const fileReader = new FileReader();
        fileReader.onload = async (event) => {
          const arrayBuffer = event.target.result as ArrayBuffer;
          const typedarray = new Uint8Array(arrayBuffer);
          // @ts-ignore
          await pdfjsLib.getDocument(typedarray).promise.then(async (pdfDoc: any) => {
            if(pdfDoc.numPages > 200){
              alert("PDFのページ数が200ページを超過しています。200ページ以下にファイルを分割してアップロードしてください。");
              return;
            }else{
              upload(file);
            }
          });
        }
        fileReader.readAsArrayBuffer(file[0]);
      }else{
        upload(file);
      }
    }

    /************************************************************
     * 画像Zipドロップ
     ************************************************************/

    const upload = async (file: any[]) => {

      state.errors = [];
      
      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', file[0]);
      fd.append('file_name', file[0].name);
      fd.append('submitted_at', state.submitted_at ? state.submitted_at : "");
      fd.append('sheet_type', context.root.$store.state.sheet_type);

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/webup_list/upload`, fd).then(async response => {
        alert("画像読込が完了しましたらメールでお知らせします。しばらくお待ちください。");
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 削除
     ************************************************************/

    const destroy = async (id: number) => {

      if(!window.confirm("アップロードデータを削除します。よろしいですか？")){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/teacher/webup_list/${id}`).then(async response => {
        alert("処理が完了しました。");
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * mounted
     ******************************/

    onMounted(async () => {
      state.sheetTypeName = Common.getSheetTypeName(context.root.$store.state.sheet_type);
      state.condition = context.root.$store.state.webupListCondition;
      await search();
      state.isMounted = true;
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      upload,
      statusClassStyle,
      convertUploadedAt,
      searchClick,
      clearCondition,
      convertWebupStatusToText,
      destroy,
      changePage,
      onDrop,
    };
  }
});

